module.exports = __webpack_public_path__ + "static/media/meet_usama_logo.24d7a631.png";